// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BrandsV4,
  UnderwritableEntitiesV4,
  AppraisalsV2,
  UserUwAcknowledgmentsV2,
  BusinessCardWithInterests,
  TargetedPropertySuperView,
  SmbSuperViewConnection,
} from "./types";


export default __t.row({
  underwritableEntityId: __t.uuid().name("underwritable_entity_id"),
  get underwritableEntity() {
    return UnderwritableEntitiesV4.name("underwritable_entity");
  },
  get brand() {
    return BrandsV4;
  },
  get businessCards() {
    return __t.array(BusinessCardWithInterests).name("business_cards");
  },
  currentPurchasingPower: __t.option(__t.f64()).name("current_purchasing_power"),
  get targetedProperties() {
    return __t.array(TargetedPropertySuperView).name("targeted_properties");
  },
  hasFinancialConnections: __t.bool().name("has_financial_connections"),
  get connections() {
    return __t.array(SmbSuperViewConnection);
  },
  get appraisals() {
    return __t.array(AppraisalsV2);
  },
  get userUwAcknowledgments() {
    return __t.array(UserUwAcknowledgmentsV2).name("user_uw_acknowledgments");
  },
});
